import React from 'react';
import { TableHead } from './table';
import { cn } from '../../lib/utils';

interface SortableHeaderProps extends React.HTMLAttributes<HTMLTableCellElement> {
  isSorted?: 'asc' | 'desc' | false;
  onSort?: () => void;
  children: React.ReactNode;
}

export const SortableHeader = React.forwardRef<
  HTMLTableCellElement,
  SortableHeaderProps
>(({ className, isSorted, onSort, children, ...props }, ref) => {
  return (
    <TableHead
      ref={ref}
      className={cn(
        "cursor-pointer select-none",
        className
      )}
      onClick={onSort}
      {...props}
    >
      <div className="flex items-center gap-1">
        {children}
        {isSorted && (
          <span className="ml-1">
            {isSorted === 'asc' ? '↑' : '↓'}
          </span>
        )}
      </div>
    </TableHead>
  );
});

SortableHeader.displayName = "SortableHeader"; 